<template>
    <div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                </colgroup>
              <tr v-if="hasData()">
                <td class="c_t_title">등록일</td>
                <td>
                  {{ createData }}
                </td>
              </tr>
              <tr>
                <td class="c_t_title">노출여부</td>
                 <td>
                    <div class="select_wrap">
                        <el-select v-model="display" @change="parentChange('display',display)">
                            <el-option :label="'노출'" :value="1"></el-option>
                            <el-option :label="'미노출'" :value="0"></el-option>
                        </el-select>
                    </div>
                  </td>
              </tr>
              <tr>
                <td class="c_t_title">난이도</td>
                <td>
                  <div class="select_wrap">
                    <el-select v-model="level" @change="parentChange('level',level)">
                      <el-option :label="'입문'" :value="0"></el-option>
                      <el-option :label="'초급'" :value="1"></el-option>
                      <el-option :label="'중·고급'" :value="2"></el-option>
                      <!-- <el-option :label="'고급'" :value="3"></el-option> -->
                    </el-select>
                  </div>
                </td>
              </tr>
                <tr>
                    <td class="c_t_title">분야</td>
                  <td>
                        <div class="select_wrap">
                          <el-select v-model="category" @change="parentChange('category',category)">
                            <el-option :value="ca.oc_idx" :label="ca.oc_kor" v-for="ca in Categories" :key="`ca${ca.oc_idx}`"></el-option>
                          </el-select>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="c_t_title">주제명(한국어)</td>
                    <td>
                        <div>
                            <el-input v-model="kor" maxlength="20" @input="parentChange('kor', kor)"></el-input>
                            <div class="input_error" v-if="validation.hasError('kor')">{{ validation.firstError('kor') }}</div>
                        </div>
                    </td>
                </tr>
              <tr>
                <td class="c_t_title">주제명(영어)</td>
                <td>
                  <div>
                    <el-input v-model="eng" maxlength="20" @input="parentChange('eng', eng)"></el-input>
                    <div class="input_error">{{ validation.firstError('eng') }}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="c_t_title">주제명(중국어)</td>
                <td>
                  <div>
                    <el-input v-model="cn" maxlength="20" @input="parentChange('cn', cn)"></el-input>
                    <div class="input_error">{{ validation.firstError('cn') }}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="c_t_title">학습자료</td>
                <td>
                  <div @click="changeType('files')">
                    <el-upload
                        class="upload-demo text-left"
                        :auto-upload="false"
                        action=""
                        accept=".pdf"
                        :show-file-list="false"
                        :file-list="files"
                        :thumbnail-mode="true"
                        :on-change="onlyOneFileUpload"
                    >
                      <el-button size="small"  class="mr15" type="primary">파일 업로드</el-button>
                      <span v-if="hasFile('files')">
                        <el-link @click.stop="fileDown(files)" class="c_blue">
                          <div class="inline-block" >{{ files.hasOwnProperty('name')? files.name : files[0].name }}
                          </div>
                        </el-link>
                        <el-button  @click.stop="removeFile()" style="cursor:pointer; margin-left: 10px;  margin-top: 5px; font-size: 15px" size="mini" round>
                          <i class="el el-icon-delete" ></i>
                        </el-button>
                        </span>
                    </el-upload>
                    <div class="input_error mt5">.pdf만 등록가능합니다. 5MB 이하의 파일만 가능합니다.</div>
                  </div>
                </td>
              </tr>
              <tr>
                  <td class="c_t_title">카드 이미지</td>
                  <td colspan="3">
                      <div class="" @click="changeType('cardFile')">
                          <el-upload
                              class="avatar-uploader content-image"
                              action=""
                              list-type="picture-card"
                              :show-file-list="false"
                              :file-list="cardFile"
                              :auto-upload="false"
                              :on-change="onlyOnePhotoChange"
                          >
                              <img v-if="hasImage()" :src="cardFile[0].org_url ? cardFile[0].org_url : cardFile[0].url" class="avatar">
                              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                              <div slot="tip" class="el-upload__tip c_danger">N x N 사이즈에 최적화되어있습니다.</div>
                              <div slot="tip" class="el-upload__tip c_danger">jpg/png 종류의 파일과 10MB 이하의 파일만 가능합니다.</div>
                          </el-upload>
                      </div>
                  </td>
              </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import elFileMixins from "@/mixins/elFileMixins";
    import topicValidator from "@/mixins/validators/topicValidator";
    import util from "@/mixins/util";
    import EventBus from "@/utils/event-bus";

    export default {
        name: "TopicWriteDefaultLayout",
        mixins: [elFileMixins,topicValidator],
        components: {},
        inject: ['topicWriteSetData'],
        provide() {
            return {}
        },
        props: {
            topicData: {default: () => {}},
            Categories: {default: () => []},
        },
        data() {
            return {
              fileType:'files',
              createData:'',
                fileMaxSize: 5000000,
            }
        },
        created() {
        },
        mounted() {
          if(this.hasData()){ // 수정
            this.initData();
          }else { // 등록
            this.createSetData();
          }
          EventBus.$on('TopicWriteDefaultLayoutValidator', this.checkValidator);
        },
        beforeDestroy() {
          EventBus.$off('TopicWriteDefaultLayoutValidator')
        },
        destroyed() {},
        computed: {
        },
        methods: {
          createSetData(){
            if(!util.isEmpty(this.Categories)){
              this.category = this.Categories[0].oc_idx;
              this.parentChange('category', this.category);
            }
            this.parentChange('display', this.display);
            this.parentChange('level', this.level);
            this.parentChange('files',this.files)
            this.parentChange('deleteFiles',this.deleteFiles)
            this.parentChange('CardFile',this.CardFile)
          },
            initData() {
                this.createData = this.topicData.created_at;

                this.category = this.topicData.oc_idx;
                this.parentChange('category', this.category);

                this.display = this.topicData.ot_display;
                this.parentChange('display', this.display);

                this.level = this.topicData.ot_level;
                this.parentChange('level', this.level);

                this.kor = this.topicData.ot_kor;
                this.parentChange('kor', this.kor);

                this.cn = this.topicData.ot_cn;
                this.parentChange('cn', this.cn);

                this.eng = this.topicData.ot_eng
                this.parentChange('eng', this.eng);

                if(!util.isEmpty(this.topicData.TopicFile)){ // 선택값
                  this.topicData.TopicFile[0].name = this.topicData.TopicFile[0].org_name;
                  this.topicData.TopicFile[0].url = this.topicData.TopicFile[0].org_url;
                  this.files = this.topicData.TopicFile

                  this.parentChange('files', this.files);
                  this.parentChange('deleteFiles', this.deleteFiles);
                }else {
                  this.parentChange('files', this.files);
                  this.parentChange('deleteFiles', this.deleteFiles);
                }

                if (!util.isEmpty(this.topicData.CardFile) && !util.isEmpty(this.topicData.CardFile[0].a_idx)) {
                this.cardFile = this.topicData.CardFile.slice();
                util.Array.each(this.cardFile, (file, index, arr) => {
                  file.url = file.org_url;
                  file.name = file.org_name;
                })
                this.parentChange("cardFile", this.cardFile);
                }
            },
            parentChange(key, value) {
                this.topicWriteSetData(key, value);
            },
            hasFile(typeName) {
              return !util.isEmpty(this[typeName]) && (!util.isEmpty(this[typeName].url || !util.isEmpty(this[typeName].org_url)));
            },
            hasData(){
              return !util.isEmpty(this.topicData)
            },
            checkValidator(dataArr) {
              this.$validate(dataArr)
            },
            removeFile(){
            if(this.hasData()){ // 수정일 경우
              this.deleteFiles.push(this.files[0]);
              this.parentChange('deleteFiles',this.deleteFiles)
            }
              this.files = [];
              this.parentChange('files',this.files)
            },
            fileDown(file){
            // if(!file.hasOwnProperty('org_url') && file.org_url === undefined){
            //   return
            // }
              let fileName = '첨부파일';
              const url = file[0].org_url
              const anchor = document.createElement('a');

              anchor.href = url;
              anchor.style.display = 'none';
              anchor.target='_blank'
              anchor.setAttribute('download', fileName);
              document.body.appendChild(anchor);
              anchor.click();
            },
            hasImage() {
              return !util.isEmpty(this.cardFile);
            },
        },
        watch: {
        },
    }
</script>

<style scoped>

</style>
